/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IERC721Metadata__factory } from "./IERC721Metadata__factory";
